import { useMemo } from "react";

import createFluentTheme from "./createFluentTheme";

const useTheme = (themePreference: string) =>

  useMemo(() => createFluentTheme(themePreference), [themePreference]);

export default useTheme;